const exporting = {
  fallbackToExportServer: false,
  allowHTML: true,
  enabled: false,
  sourceWidth: 960,
  sourceHeight: 540
};

export default exporting;
